import { useQuery } from '@tanstack/react-query';
import { sdkRequest } from '@eventbrite/legacy-infra.http';

import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';

import { transformTrackingBeacons, type TrackingBeaconsResponse, type TrackingBeacons } from './transform';

const getTrackingBeacons = (eventId: string): Promise<TrackingBeaconsResponse> => {
  return sdkRequest(
    `/events/${eventId}/tracking_beacons/`,
    undefined,
    process.env.NEXT_PUBLIC_PROXY_API_V3 ? '/e' : '',
  );
};

export const useTrackingBeacons = (): [TrackingBeacons | null, boolean] => {
  const { id: eventId } = useBasicInfo();
  const { data, isLoading } = useQuery({
    queryKey: ['trackingBeacons'],
    queryFn: () => getTrackingBeacons(eventId),
  });
  return [transformTrackingBeacons(data), isLoading];
};
